import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MapService } from "../../view/services/map.service";
import { environment } from "../../../environments/environment";

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.css']
})
export class SearchComponent implements OnInit, OnDestroy {
  sqlForm = new FormGroup({
    capa: new FormControl('', Validators.required) as any,
    atributo: new FormControl('', Validators.required) as any,
    condicion: new FormControl('', Validators.required) as any,
    valor: new FormControl('', Validators.required) as any,
  });

  catastralForm = new FormGroup({
    codigo_ant: new FormControl(''),
    codigo: new FormControl(''),
    matricula: new FormControl('')
  });

  viewCatastral = environment.modules.searchCatastral;
  layers: any;
  layerControl = new FormControl('');
  selectForm = 0;
  progressBar = false;
  searchResults: any[] = [];
  highlightItem: any;
  validCatastral = false;
  showResultsSection: boolean = false;
  matriculaActiva: boolean = false;

  constructor(protected mapService: MapService) { }

  ngOnInit(): void {
    this.layers = this.mapService.getViewMap().map.allLayers;
  }

  ngOnDestroy() {
    this.clear();
  }
  // this searches for features based on user inputs
  searchFeatures() {
    this.searchResults = [];
    this.progressBar = true;
    let consulta = "";

    switch (this.selectForm) {
      case 0:

        consulta = `${Object.keys(this.catastralForm.value)[0]} = '${Object.values(this.catastralForm.value)[0]}'`;

        this.layers.forEach(layer => {

          if (layer.title.includes("Terreno") || layer.title.includes("Predio")) {
            layer.queryFeatures({
              returnGeometry: true,
              outFields: ["*"],
              where: consulta,
              start: 0,
              num: 1000
            }).then((response) => {
              if (response.features.length != 0) {
                this.searchResults = response.features;
              }
              this.progressBar = false;
            })

          }

        });
        break

      case 1:

        const { atributo } = this.sqlForm.value;
        const searchValue = this.sqlForm.value.valor.toLowerCase();
        const fieldName = atributo.type === 'string'
          ? `Lower(${atributo.name}) ${this.sqlForm.value.condicion}`
          : `${atributo.name} ${this.sqlForm.value.condicion}`;

        consulta = searchValue && fieldName
          ? `${fieldName} ${this.sqlForm.value.condicion == 'like' ? `'%${searchValue}%'` : `'${searchValue}'`}`
          : '';

        this.sqlForm.value.capa.queryFeatures({
          returnGeometry: true,
          outFields: ["*"],
          where: consulta || "1=1",
          start: 0,
          num: 1000
        }).then((response) => {
          this.progressBar = false;
          if (response.features.length) {
            this.searchResults = response.features;
          }
        });

        break
    }

    this.showResultsSection = true;
  }
  onKeyDown(event: KeyboardEvent) {
    if (!/^\d$/.test(event.key)) {
      event.preventDefault();
    }
  }

  inputForm(event) {
    if (event.target.id == 'mat-input-3') {
      this.matriculaActiva = true
  
    
    }
    if (event.target.value != "") {
      this.validCatastral = true;
      Object.keys(this.catastralForm.controls).forEach(element => {
        if (element != event.target.attributes[3].nodeValue) {
          this.catastralForm.controls[element].disable();
        }
      });
    } else {
      this.matriculaActiva = false;
      this.validCatastral = false;
      Object.keys(this.catastralForm.controls).forEach(element => {
        this.catastralForm.controls[element].enable();
      });
    }
  }

  viewAttributesFeature(feature) {
    if (this.mapService.getViewMap().popup.visible) {
      this.mapService.getViewMap().popup.visible = false;
    }
    this.mapService.getViewMap().popup.dockEnabled = true;
    this.mapService.getViewMap().popup.spinnerEnabled = true;
    this.mapService.getViewMap().popup.collapseEnabled = false;
    this.mapService.getViewMap().popup.highlightEnabled = false;
    this.mapService.getViewMap().popup.dockOptions = {
      buttonEnabled: false,
      position: 'bottom-center'
    };
    this.mapService.getViewMap().popup.open({
      features: [feature]
    });
  }
  // this zooms to the found feature
  zoomFeature(feature) {
    const viewMap = this.mapService.getViewMap();
    const popup = viewMap.popup;
    const layer = feature.layer || feature.sourceLayer.layer;

    viewMap.goTo(feature);

    popup.visible ? popup.close() : null
    viewMap.whenLayerView(layer).then(layerView => {
      this.highlightItem ? this.highlightItem.remove() : null
      this.highlightItem = layerView.highlight(feature)
    });
  }

  clear() {
    this.searchResults = [];
    this.showResultsSection = false;
    this.progressBar = false;
    this.validCatastral = false;
    this.sqlForm.setValue({ capa: "", atributo: "", condicion: "", valor: "" });
    this.catastralForm.setValue({ codigo_ant: "", codigo: "", matricula: "" });
    Object.keys(this.catastralForm.controls).forEach(element => {
      this.catastralForm.controls[element].enable();
    });
    if (this.highlightItem) {
      this.highlightItem.remove()
    }

  }

  removeFeature(feature) {
    this.searchResults = this.searchResults.filter(item => item !== feature)
  }

  //this filters shown layers so hotspot is not visible 
  filterLayers(layers) {
    let filteredLayers = layers.items.filter(item => {
      return !item.title.toLowerCase().includes("hotspot")
    })
    return filteredLayers
  }

}
